import {
  AccountStatus,
  IAccountChangeStatus,
  IChangeResult,
  ISubscriptionCreateArguments,
  LeadStatus,
  MarketingAnalyticsEvents,
} from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class NoSubscriptionToSubscription implements IChangeFunction {
  public constructor(private toStatus: AccountStatus, private trackingEvent: MarketingAnalyticsEvents) {}

  public async validate(): Promise<IAccountChangeStatus> {
    return {
      fromStatus: 'NoActiveSubscription',
      toStatus: this.toStatus,
      success: true,
      message: '',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId?: string,
    subscriptionCreateOptions?: ISubscriptionCreateArguments,
  ): Promise<IChangeResult> {
    if (!subscriptionCreateOptions) {
      throw new Error('subscription create arguments required');
    }

    const subscription = await paymentService.subscribeToPlan(subscriptionCreateOptions);
    await userProfileService.updateUserSubscriptionDetails(
      userProfile.uid,
      subscription.id,
      subscription.plan?.id,
    );

    if (this.toStatus === 'InAppPurchase' || this.toStatus === 'EliteSubscription') {
      await userProfileService.updateLeadStatus(userProfile.uid, LeadStatus.Won);
    }

    if (this.toStatus === 'EliteSubscription' && subscription.plan) {
      await userProfileService.updateUserDefaultEquipmentToProductEquipment(userProfile, subscription.plan);
    }

    return {
      data: subscription,
      marketingAnalyticsData: {
        trackingEventName: this.trackingEvent,
      },
    };
  }
}
